import { getBackgroundColor as getGlobalBackgroundColor } from './global';
import { DATA_STATE_ACTIVE, DATA_STATE_CANCELLED, DATA_STATE_COMPLETED, DATA_STATE_CURRENT, DATA_STATE_IS_IN_DATE_RANGE, DATA_STATE_ON, DATA_STATE_SELECTED, INTERACTION_STATE_ACTIVE, INTERACTION_STATE_FOCUS_VISIBLE, INTERACTION_STATE_HOVER, } from '../../../../constants';
export function getBackgroundColor(transformer) {
    const globalBackgroundColor = getGlobalBackgroundColor(transformer);
    return Object.freeze({
        selection: { value: globalBackgroundColor.brand.orange500 },
        feedback: {
            informative: {
                contentContainer: { value: globalBackgroundColor.secondary.blue00 },
                decorative: { value: globalBackgroundColor.secondary.blue500 },
            },
            positive: {
                contentContainer: { value: globalBackgroundColor.secondary.green00 },
                decorative: { value: globalBackgroundColor.secondary.green500 },
            },
            warning: {
                contentContainer: { value: globalBackgroundColor.primary.orange00 },
                decorative: { value: globalBackgroundColor.primary.orange300 },
            },
            negative: {
                contentContainer: { value: globalBackgroundColor.primary.orange00 },
                decorative: { value: globalBackgroundColor.primary.orange700 },
            },
            exceeded: {
                positive: { value: globalBackgroundColor.secondary.green700 },
                negative: { value: globalBackgroundColor.primary.orange700 },
            },
        },
        button: {
            primary: {
                default: { value: globalBackgroundColor.brand.orange500 },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange700,
                    },
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange700,
                    },
                },
            },
            plain: {
                default: { value: globalBackgroundColor.transparent },
                // White instead of transparent otherwise box shadow cannot be applied
                withBoxShadow: { value: globalBackgroundColor.brand.white },
                withBorder: {
                    default: { value: globalBackgroundColor.brand.white },
                    dataStates: {
                        [DATA_STATE_SELECTED]: {
                            value: globalBackgroundColor.brand.orange00,
                        },
                    },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
            add: {
                default: { value: globalBackgroundColor.transparent },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
            secondary: {
                default: { value: globalBackgroundColor.brand.white },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
            dismiss: {
                default: { value: globalBackgroundColor.gray100 },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.gray200,
                    },
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.gray200,
                    },
                    [INTERACTION_STATE_FOCUS_VISIBLE]: {
                        value: globalBackgroundColor.gray200,
                    },
                },
            },
        },
        listItem: {
            marker: {
                default: { value: globalBackgroundColor.gray600 },
                attentional: {
                    xs: { value: globalBackgroundColor.brand.orange500 },
                    s: { value: globalBackgroundColor.brand.orange500 },
                },
            },
            interactionStates: {
                [INTERACTION_STATE_ACTIVE]: {
                    value: globalBackgroundColor.brand.orange00,
                },
                [INTERACTION_STATE_HOVER]: {
                    value: globalBackgroundColor.brand.orange00,
                },
            },
        },
        menuItem: {
            default: { value: globalBackgroundColor.transparent },
            interactionStates: {
                [INTERACTION_STATE_HOVER]: {
                    value: globalBackgroundColor.brand.orange00,
                },
                [INTERACTION_STATE_ACTIVE]: {
                    value: globalBackgroundColor.brand.orange00,
                },
                [INTERACTION_STATE_FOCUS_VISIBLE]: {
                    value: globalBackgroundColor.brand.orange00,
                },
            },
            dataStates: {
                [DATA_STATE_SELECTED]: {
                    default: { value: globalBackgroundColor.brand.orange00 },
                    multipleSelectable: { value: globalBackgroundColor.brand.orange00 },
                },
            },
        },
        bottomSheetSlideButton: { value: globalBackgroundColor.gray100 },
        form: {
            input: {
                default: { value: globalBackgroundColor.white },
            },
            switch: {
                container: {
                    default: { value: globalBackgroundColor.gray100 },
                    interactionStates: {
                        [INTERACTION_STATE_HOVER]: { value: globalBackgroundColor.gray200 },
                        [INTERACTION_STATE_ACTIVE]: { value: globalBackgroundColor.gray200 },
                    },
                    dataStates: {
                        [DATA_STATE_ON]: {
                            value: globalBackgroundColor.brand.orange500,
                            interactionStates: {
                                [INTERACTION_STATE_HOVER]: {
                                    value: globalBackgroundColor.brand.orange300,
                                },
                                [INTERACTION_STATE_ACTIVE]: {
                                    value: globalBackgroundColor.brand.orange300,
                                },
                            },
                        },
                    },
                },
                knob: { value: globalBackgroundColor.brand.white },
            },
            datepicker: {
                date: {
                    default: { value: globalBackgroundColor.transparent },
                    interactionStates: {
                        [INTERACTION_STATE_HOVER]: {
                            value: globalBackgroundColor.brand.orange00,
                        },
                    },
                    dataStates: {
                        [DATA_STATE_SELECTED]: {
                            value: globalBackgroundColor.brand.orange500,
                        },
                        [DATA_STATE_IS_IN_DATE_RANGE]: {
                            value: globalBackgroundColor.gray00,
                        },
                    },
                },
            },
            slider: {
                indicator: { value: globalBackgroundColor.brand.orange500 },
                track: { value: globalBackgroundColor.gray00 },
                knob: {
                    default: { value: globalBackgroundColor.white },
                },
            },
        },
        pageHeader: { value: globalBackgroundColor.brand.white },
        pageFooter: { value: globalBackgroundColor.brand.white },
        contentContainer: {
            plain: {
                default: { value: globalBackgroundColor.brand.white },
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
            tinted: { value: globalBackgroundColor.gray00 },
        },
        pagination: {
            dot: {
                default: { value: globalBackgroundColor.gray100 },
                dataStates: {
                    [DATA_STATE_ACTIVE]: { value: globalBackgroundColor.brand.orange500 },
                },
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: { value: globalBackgroundColor.gray200 },
                },
            },
        },
        backdrop: { value: globalBackgroundColor.black },
        progressIndicator: {
            track: { value: globalBackgroundColor.gray00 },
            container: {
                interactionStates: {
                    [INTERACTION_STATE_ACTIVE]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
            indicator: {
                default: { value: globalBackgroundColor.brand.orange500 },
            },
        },
        modal: { value: globalBackgroundColor.white },
        qualitativeData: {
            first: { value: globalBackgroundColor.primary.orange500 },
            second: { value: globalBackgroundColor.secondary.blue700 },
            third: { value: globalBackgroundColor.secondary.green500 },
            fourth: { value: globalBackgroundColor.secondary.purple500 },
            fifth: { value: globalBackgroundColor.primary.orange100 },
            sixth: { value: globalBackgroundColor.secondary.blue300 },
            seventh: { value: globalBackgroundColor.secondary.green100 },
            eighth: { value: globalBackgroundColor.secondary.purple100 },
        },
        sequentialData: {
            firstA: { value: globalBackgroundColor.primary.orange700 },
            firstB: { value: globalBackgroundColor.primary.orange500 },
            firstC: { value: globalBackgroundColor.primary.orange300 },
            firstD: { value: globalBackgroundColor.primary.orange100 },
            secondA: { value: globalBackgroundColor.secondary.blue700 },
            secondB: { value: globalBackgroundColor.secondary.blue500 },
            secondC: { value: globalBackgroundColor.secondary.blue300 },
            secondD: { value: globalBackgroundColor.secondary.blue100 },
            thirdA: { value: globalBackgroundColor.secondary.green700 },
            thirdB: { value: globalBackgroundColor.secondary.green500 },
            thirdC: { value: globalBackgroundColor.secondary.green300 },
            thirdD: { value: globalBackgroundColor.secondary.green100 },
            fourthA: { value: globalBackgroundColor.secondary.purple700 },
            fourthB: { value: globalBackgroundColor.secondary.purple500 },
            fourthC: { value: globalBackgroundColor.secondary.purple300 },
            fourthD: { value: globalBackgroundColor.secondary.purple100 },
        },
        barLoader: {
            indicator: { value: globalBackgroundColor.brand.orange500 },
            track: { value: globalBackgroundColor.gray00 },
        },
        collapsibleSectionTrigger: {
            interactionStates: {
                [INTERACTION_STATE_HOVER]: {
                    value: globalBackgroundColor.primary.orange00,
                },
            },
        },
        tab: {
            indicator: {
                dataStates: {
                    [DATA_STATE_SELECTED]: { value: globalBackgroundColor.brand.orange500 },
                },
            },
        },
        skipLink: { value: globalBackgroundColor.secondary.blue700 },
        pipeline: {
            stepContent: {
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalBackgroundColor.brand.white },
                    [DATA_STATE_COMPLETED]: { value: globalBackgroundColor.gray00 },
                    [DATA_STATE_CANCELLED]: { value: globalBackgroundColor.gray00 },
                },
            },
            indicator: {
                default: { value: globalBackgroundColor.white },
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalBackgroundColor.brand.orange500 },
                    [DATA_STATE_COMPLETED]: {
                        value: globalBackgroundColor.brand.orange500,
                    },
                    [DATA_STATE_CANCELLED]: {
                        value: globalBackgroundColor.brand.orange500,
                    },
                },
            },
        },
        table: {
            headerCell: {
                interactionStates: {
                    [INTERACTION_STATE_HOVER]: {
                        value: globalBackgroundColor.brand.orange00,
                    },
                },
            },
        },
        stepIndicator: {
            indicator: {
                default: { value: globalBackgroundColor.white },
                dataStates: {
                    [DATA_STATE_COMPLETED]: {
                        value: globalBackgroundColor.brand.orange500,
                    },
                    [DATA_STATE_CURRENT]: { value: globalBackgroundColor.white },
                },
            },
        },
        badge: {
            filter: {
                dismissible: { value: globalBackgroundColor.gray100 },
            },
        },
    });
}
